import React, {useContext, useState, useEffect} from 'react'
import { Modal } from 'react-bootstrap';
import { NormasContext } from '../../../context/NormasContext';
import { jwtDecode } from "jwt-decode"
import "./ModalNewProyecto.scss"

function ModalNewProyectoEmpresa(props) {

    const auth = localStorage.getItem("token")
    const jwtParse = jwtDecode(auth)
    const user = jwtParse.apirest.objeto

    const { normas, fetchNormas, fetchProyectosNormas } = useContext(NormasContext)

    const [seleccionadas, setSeleccionadas] = useState([])
    const [errorModal, setErrorModal] = useState(null)

    useEffect(() => {
        fetchNormas()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleClose = () => {
        setSeleccionadas([])
        setErrorModal(null)
        props.onHide()
    }

    const handleCheckboxChange = (id) => {
        setSeleccionadas((prev) =>
        prev.includes(id)
            ? prev.filter((i) => i !== id)
            : [...prev, id]
        );
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if(seleccionadas.length === 0){
            setErrorModal("Debe escoger al menos una norma")
        } else {
            for (const n of seleccionadas){
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/aderirNormativa`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        user,
                        idNorma: n,
                        idEmpresa: parseInt(user.idEmpresa),
                    })
                })
                const data = await res.json()
                if(data.status !== 0){
                    setErrorModal(data.codeError)
                } else {
                    props.onHide()
                    handleClose()
                    // actualizar proyectos
                    fetchProyectosNormas({
                        user,
                        idEmpresa: parseInt(user.idEmpresa)
                    })
                }
            }
            handleClose()
        }
    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className='modal__normas'
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                    <h3 className='m-0'>Escoge la norma</h3>
                    <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className='form__normas d-flex flex-column' onSubmit={handleSubmit}>
                    <div className='groupNormas__container mb-4'>
                        <div className='groupNormas d-flex flex-column'>
                            <p className='fw-semibold text-dark-emphasis'>Normas disponibles</p>
                            {normas?.objeto?.map((n,i) => (
                                <div key={i} className='d-flex flex-row align-items-center'>
                                    <input 
                                        className="input__normas form-check-input me-2" 
                                        type="checkbox" 
                                        checked={seleccionadas.includes(n.id_norma)}
                                        onChange={() => handleCheckboxChange(n.id_norma)}
                                    />
                                    <label className="form-check-label" >
                                        {n.nombre}
                                    </label>
                                </div>
                            ))}
                        </div>
                        <div className='groupNormas d-flex flex-column'>
                            <p className='fw-semibold text-dark-emphasis'>Sistema de Gestión Empresarial</p>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 45001
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 21001
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 37001
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 37301
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 30401
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 55001
                                </label>
                            </div>
                        </div>
                        <div className='groupNormas d-flex flex-column'>
                            <p className='fw-semibold text-dark-emphasis'>Seguridad y Continuidad</p>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO/IEC 27001
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO/IEC 27017
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO/IEC 27018
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 22301
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 31000
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 28000
                                </label>
                            </div>
                        </div>
                        <div className='groupNormas d-flex flex-column'>
                            <p className='fw-semibold text-dark-emphasis'>Tecnología de la Información</p>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO/IEC 20000-1
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO/IEC 29110
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO/IEC 25010
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='groupNormas__container mb-4'>
                        <div className='groupNormas d-flex flex-column'>
                            <p className='fw-semibold text-dark-emphasis'>Laboratorios y Evaluaciones Técnicas</p>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO/IEC 17025
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO/IEC 17020
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO/IEC 17021
                                </label>
                            </div>
                        </div>
                        <div className='groupNormas d-flex flex-column'>
                            <p className='fw-semibold text-dark-emphasis'>Agroindustria, Seguridad Alimentaria y Trazabilidad</p>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 22000
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 26000
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 14046
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 14067
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 20400
                                </label>
                            </div>
                        </div>
                        <div className='groupNormas d-flex flex-column'>
                            <p className='fw-semibold text-dark-emphasis'>Industria y Producción</p>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO/TS 16949
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 3834
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 13485
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 14644
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 10012
                                </label>
                            </div>
                        </div>
                        <div className='groupNormas d-flex flex-column'>
                            <p className='fw-semibold text-dark-emphasis'>Sostenibilidad y clima</p>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 14065
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 14001
                                </label>
                            </div>
                            <div className='d-flex flex-row align-items-center'>
                                <input 
                                    className="form-check-input me-2" 
                                    type="checkbox" 
                                    disabled
                                />
                                <label className="form-check-label" >
                                    ISO 50001
                                </label>
                            </div>
                        </div>
                    </div>
                    {errorModal !== null && (
                        <span className='align-self-center text-danger mb-4'><i className="bi bi-exclamation-circle me-1"></i>{errorModal}</span>
                    )}
                    <button 
                        type='submit' 
                        className='px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                    >
                        + agregar norma
                    </button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalNewProyectoEmpresa